import type { Country } from '@onhandtech/onhand-fe-shared/lib/api/legacy/countries/get-countries/get-countries.types'
import type { RequestError } from '@onhandtech/onhand-fe-shared/lib/contracts/requests/requests'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { moduleName } from './countries.types'

type StateType = {
  data: Country[] | null
  error: RequestError | null
  loading: boolean
}

const initialState: StateType = {
  data: null,
  error: null,
  loading: false,
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true
      state.error = null
    },
    fetchSuccess: (state, action: PayloadAction<Country[]>) => {
      state.data = action.payload
      state.loading = false
    },
    fetchFailure: (state, action: PayloadAction<RequestError>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export default slice
